import React, { PureComponent } from 'react';
import { Modal, Header, Button, Icon, Form } from 'semantic-ui-react';

class EditShareIframeModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      accountsInput: '',
      campaignsInput: '',
      fundingInput: '',
      oemInput: '',
      marketInput: ''
    };
  }

  componentDidMount() {
    this.setInitialFormValuesState();
  }

  setInitialFormValuesState = () => {
    const { iframe } = this.props;
    const { account, campaign, funding, oem, market } = iframe;
    this.setState({
      accountsInput: account,
      campaignsInput: campaign,
      fundingInput: funding,
      oemInput: oem,
      marketInput: market
    });
  };

  handleChange = (event, { name, value }) => this.setState({ [name]: value });

  saveEditedIframe = () => {
    const { saveEditedIframe, toggleEditShareIframeModal, iframe } = this.props;
    const {
      accountsInput,
      campaignsInput,
      fundingInput,
      oemInput,
      marketInput
    } = this.state;
    const newIframe = {
      ...iframe,
      account: accountsInput,
      campaign: campaignsInput,
      funding: fundingInput,
      oem: oemInput,
      market: marketInput
    };
    if (saveEditedIframe) saveEditedIframe(newIframe);
    if (toggleEditShareIframeModal) toggleEditShareIframeModal();
  };

  render() {
    const {
      accountsInput,
      campaignsInput,
      fundingInput,
      oemInput,
      marketInput
    } = this.state;
    const {
      shareUrl,
      showEditShareIframeModal,
      openEditShareIframeModalButton,
      toggleEditShareIframeModal
    } = this.props;

    return (
      <Modal
        size="small"
        dimmer="inverted"
        trigger={openEditShareIframeModalButton}
        open={showEditShareIframeModal}
        onClose={toggleEditShareIframeModal}
      >
        <Header icon="edit outline">
          Edit Your Insights Preview Link Details:{' '}
          {
            <a rel="noopener noreferrer" target="_blank" href={shareUrl}>
              {shareUrl}
            </a>
          }{' '}
        </Header>
        <Modal.Content>
          <Form>
            <Form.TextArea
              label="Accounts"
              name="accountsInput"
              value={accountsInput}
              onChange={this.handleChange}
            />
            <Form.TextArea
              label="Campaigns"
              name="campaignsInput"
              value={campaignsInput}
              onChange={this.handleChange}
            />
            <Form.TextArea
              label="Funding"
              name="fundingInput"
              value={fundingInput}
              onChange={this.handleChange}
            />
            <Form.TextArea
              label="OEM"
              name="oemInput"
              value={oemInput}
              onChange={this.handleChange}
            />
            <Form.TextArea
              label="Market"
              name="marketInput"
              value={marketInput}
              onChange={this.handleChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={toggleEditShareIframeModal}>
            <Icon name="close" /> Close
          </Button>
          <Button color="green" onClick={this.saveEditedIframe}>
            <Icon name="save outline" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default EditShareIframeModal;



// WEBPACK FOOTER //
// ./src/screens/InsightsPreview/EditShareIframeModal.js